<template>
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       viewBox="0 0 24 24">
    <path d="M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z"/>
  </svg>
</template>

<script>
export default {
  name: "FormatAlignCenterIcon",
  props: {
    fillColor: {
      type: String,
      default: "currentColor"
    },
  }
}
</script>
